/**
 * ======================================
 * Mutation types for the auth module
 * ======================================
 *
 * The mutation types that are available
 * on the auth module.
 */

export const SET_LIST_PRODUCT = 'SET_LIST_PRODUCT';

export default {
  SET_LIST_PRODUCT,
};
